import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { TooltipRoot } from "../vendor/@base-ui/react/tooltip/root/TooltipRoot.js";
import { TooltipTrigger } from "../vendor/@base-ui/react/tooltip/trigger/TooltipTrigger.js";
import { TooltipPortal } from "../vendor/@base-ui/react/tooltip/portal/TooltipPortal.js";
import { TooltipPositioner } from "../vendor/@base-ui/react/tooltip/positioner/TooltipPositioner.js";
import { TooltipPopup } from "../vendor/@base-ui/react/tooltip/popup/TooltipPopup.js";
import { TooltipProvider as TooltipProvider$1 } from "../vendor/@base-ui/react/tooltip/provider/TooltipProvider.js";
const Tooltip = React.forwardRef(function Tooltip2({
  content,
  children,
  side = "top",
  align = "center",
  sideOffset = 8,
  delay,
  closeDelay,
  open,
  defaultOpen,
  onOpenChange,
  disabled,
  container,
  className
}, ref) {
  return /* @__PURE__ */ jsxs(TooltipRoot, { open, defaultOpen, onOpenChange, disabled, children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { render: children, delay, closeDelay }),
    /* @__PURE__ */ jsx(TooltipPortal, { container, children: /* @__PURE__ */ jsx(TooltipPositioner, { className: "ev-tooltip-layer", side, align, sideOffset, collisionPadding: 8, children: /* @__PURE__ */ jsx(TooltipPopup, { ref, role: "tooltip", className: cx("ev-tooltip", "ev-root", className), children: content }) }) })
  ] });
});
Tooltip.displayName = "Tooltip";
function TooltipProvider({ children, delay, closeDelay, timeout }) {
  return /* @__PURE__ */ jsx(TooltipProvider$1, { delay, closeDelay, timeout, children });
}
export {
  Tooltip,
  TooltipProvider
};
//# sourceMappingURL=Tooltip.js.map
